import React from "react";
// @ts-ignore
import NavBar from "../../screens/SatCourse/CoursesScreen";
import { BsArrowLeft } from "react-icons/bs";
import { RiTimer2Fill } from "react-icons/ri";
import { GrFormPrevious } from "react-icons/gr";
import { MdOutlineNavigateNext } from "react-icons/md";
// @ts-ignore
import ExpandArrow from "../../Assets/Images/Sat-images/export-arrow.webp";

export interface MockMathQuestion {
  question: string;
}

export interface MockMathAnswer {
  answer: string;
}

export interface MockTestMathematicsProps {
  isLoading?: boolean;
  isError?: string | boolean;
  Error?: string;
  title: string;
  HandleId: () => void;
  data: MockMathQuestion[];
  answer: MockMathAnswer[];
  HandleBack: () => void;
}

const MockTestMathematics: React.FC<MockTestMathematicsProps> = (props) => {
  let alphabet = 97;
  return (
    <>
      {props.isLoading ? (
        <h1>LOADING.........</h1>
      ) : (
        <div className="Home-Container">
          {props.isError ? (
            <h1>{props.Error}</h1>
          ) : (
            <div className="home-sub-container">
              <div>
                <NavBar />
              </div>
              <div className="main-right-container">
                <div className="mock-reading-first-section">
                  <div
                    onClick={() => {
                      props.HandleBack();
                    }}
                  >
                    <BsArrowLeft size="23px" />
                  </div>
                  <div className="timer-panel-mock-reading">
                    <RiTimer2Fill size="23px" />
                    <span>70:00</span>
                  </div>
                </div>
                <div className="mock-reading-second-section">
                  <div className="mock-reading-sub-section">
                    <div>Mathematics</div>
                    <div>
                      <img src={ExpandArrow} width="25px" height="25px" alt="Expand" />
                    </div>
                  </div>
                  <div className="mock-reading-sub-section">
                    <div className="mock-reading-quiz">Quiz</div>
                    <div className="mock-test-reading-question">
                      Question1/27
                    </div>
                  </div>
                </div>
                <div className="container-sat-reading-scroll">
                  <div className="reading-sat-left-side">
                    {props.data?.length > 0 &&
                      props.data.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <ol className="mathematics-mock-ol">
                              <li>
                                <div>{item.question}</div>
                              </li>
                            </ol>
                            <div className="mock-math-heading-table">
                              Dreams Recalled during one week
                            </div>
                            <div className="mock-mathematics-table-panel">
                              <table>
                                <thead>
                                  <tr>
                                    <th></th>
                                    <th>None</th>
                                    <th>1 to 4</th>
                                    <th>5 or more</th>
                                    <th>Total</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>Group X</td>
                                    <td>15</td>
                                    <td>27</td>
                                    <td>57</td>
                                    <td>100</td>
                                  </tr>
                                  <tr>
                                    <td>Group Y</td>
                                    <td>15</td>
                                    <td>27</td>
                                    <td>57</td>
                                    <td>100</td>
                                  </tr>
                                  <tr>
                                    <td>Group Z</td>
                                    <td>15</td>
                                    <td>27</td>
                                    <td>57</td>
                                    <td>100</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </React.Fragment>
                        );
                      })}
                  </div>
                  <div className="line-div-reading"></div>
                  <div className="reading-sat-right-side">
                    <ol>
                      {props.answer?.length > 0 &&
                        props.answer.map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <li>
                                <div className="question-div-reading">
                                  Answer
                                </div>

                                <div className="choices-container-reading">
                                  {props.answer?.map((items, indexs) => {
                                    return (
                                      <React.Fragment key={indexs}>
                                        <div className="item-choices-reading-div">
                                          <p className="numbering-alpha mock-math-numbering">
                                            {String.fromCharCode(alphabet++)}
                                          </p>
                                          <p className="choices-reading-sat">
                                            {" "}
                                            {items.answer}
                                          </p>
                                        </div>
                                      </React.Fragment>
                                    );
                                  })}
                                </div>
                              </li>
                            </React.Fragment>
                          );
                        })}
                    </ol>
                  </div>
                </div>
                <div className="mock-reading-third-section">
                  <div className="mock-reading-sub-section-third">
                    <div>
                      <GrFormPrevious size="20px" />
                    </div>
                    <div className="icon-padding">Previous</div>
                  </div>
                  <div className="line-div-mock-t-read"></div>
                  <div className="mock-reading-sub-section-third">
                    <div className="icon-padding-next">Next</div>
                    <div>
                      {" "}
                      <MdOutlineNavigateNext size="20px" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default React.memo(MockTestMathematics);
